<template>
  <div class="about" style="padding:15px">
    <q-card bordered class="my-card">
      <q-card-section class="bg-cyan-8 text-white">
        <div class="row">
          <div class="col-12 col-md-9">
            <div class="row" style="margin: 0 5px 2px">
            <div class="text-h6">Laporan Perlindungan Perempuan & Anak</div>
            </div>
          </div>
          <div class="col-12 col-md-3">
            <div class="row" style="margin: 0 5px 2px">
              <q-input color="light-blue-7" v-model="cari_value" @keyup="cari_data()" outlined square :dense="true" class="bg-white" style="width:100%"/>
              <!-- <q-btn glossy class="bg-light-blue-7" @click="mdl_add = true" dense flat icon="add" style="width:15%">
                <q-tooltip class="bg-light-blue-7" transition-show="flip-right" transition-hide="flip-left" :offset="[10, 10]">
                  Tambah Data
                </q-tooltip>
              </q-btn> -->
            </div>
          </div>
        </div>
      </q-card-section>

      <q-separator dark inset />

      <q-card-section>
        <div class="tbl_responsive">
          <!-- =================================================== KONTENT =========================================================== -->
            <table width="100%">
              <tr class="h_table_head bg-cyan-2">
                <th width="2.5%" class="text-center">No</th>
                <th width="10%">Pelapor</th>
                <th width="15%">Kategori Aduan</th>
                <th width="15%">Keterangan</th>
                <th width="5%" class="text-center">Foto</th>
                <th width="5%" class="text-center">Status</th>
                <th width="7.5%" class="text-center">#</th>
              </tr>
              <tr class="h_table_body" v-for="(data, index ) in list_data" :key="data.id">
                <td class="text-center">{{index+1}}</td>
                <td>{{data.nama_user}}</td>
                <td>{{data.jenis_uraian}}</td>
                <td>{{data.uraian}}</td>
                <td class="text-center">
                  <q-img :src="file_path+data.file" style="width: 75px; height: 75px; border-radius: 15px;" @click="mdl_open = true, selectData(data)">
                    <q-tooltip class="bg-light-blue-7" transition-show="flip-right" transition-hide="flip-left" :offset="[10, 10]">
                        Lihat Image
                    </q-tooltip>
                  </q-img>
                </td>
                <td class="text-center" >
                    <div v-if="data.status == 'proses'">
                      <q-btn class="tbl_btn" color="orange-7" glossy icon="hourglass_full">
                        <q-tooltip class="bg-orange-7" transition-show="flip-right" transition-hide="flip-left" :offset="[10, 10]">{{data.keterangan}}</q-tooltip>
                      </q-btn>
                    </div>
                    <div v-if="data.status == 'selesai'" >
                      <q-btn class="tbl_btn" color="light-blue-7" glossy icon="check">
                        <q-tooltip class="bg-light-blue-7" transition-show="flip-right" transition-hide="flip-left" :offset="[10, 10]">{{data.keterangan}}</q-tooltip>
                      </q-btn>
                    </div>
                    <div v-if="data.status == 'dikembalikan'" >
                      <q-btn class="tbl_btn" color="deep-orange-7" glossy icon="clear">
                        <q-tooltip class="bg-deep-orange-7" transition-show="flip-right" transition-hide="flip-left" :offset="[10, 10]">{{data.keterangan}}</q-tooltip>
                      </q-btn>
                    </div>
                </td>
                <td class="text-center">
                  <q-btn-group>
                    <q-btn @click="mdl_lokasi = true, selectData(data)" glossy color="cyan-7" icon="place" class="tbl_btn">
                      <q-tooltip class="bg-cyan-7" transition-show="flip-right" transition-hide="flip-left" :offset="[10, 10]">
                        Lihat Lokasi
                      </q-tooltip>
                    </q-btn>
                    <q-btn @click="mdl2 = true, selectData(data)" glossy color="light-blue-7" icon="check" class="tbl_btn">
                      <q-tooltip class="bg-light-blue-7" transition-show="flip-right" transition-hide="flip-left" :offset="[10, 10]">
                        Delegasikan Laporan
                      </q-tooltip>
                    </q-btn>
                    <q-btn @click="mdl3 = true, selectData(data)" glossy color="deep-orange-7" icon="clear" class="tbl_btn">
                      <q-tooltip class="bg-deep-orange-7" transition-show="flip-right" transition-hide="flip-left" :offset="[10, 10]">
                        Tolak Laporan
                      </q-tooltip>
                    </q-btn>
                  </q-btn-group>
                </td>
              </tr>
            </table>

          <!-- =================================================== KONTENT =========================================================== -->
        </div>
        <hr class="hrpagin">
        <br>
        <div class="text-center">
          <q-btn @click="btn_prev" glossy color="cyan-6" icon="skip_previous" class="paginate_btn" />
            <span class="h_pagination">&nbsp; {{page_first}} - {{page_last}} &nbsp;</span>
          <q-btn @click="btn_next" glossy color="cyan-6" icon="skip_next" class="paginate_btn" />
        </div>
        <br>
      </q-card-section>
    </q-card>

          <!-- =================================================== MODAL =========================================================== -->

            <!-- ================================================ MODAL HAPUS ================================================ -->
            <q-dialog v-model="mdl_hapus" persistent>
                    <q-card class="mdl-sm ">
                      <q-card-section class="q-pt-none text-center bg-deep-orange-3">
                          <form @submit.prevent="removeData(form.id, form.file_old)">
                              <br>
                              <img src="img/alert.png" alt="" width="75"> <br>
                              <span class="h_notifikasi">APAKAH ANDA YAKIN INGIN MENGHAPUS DATA INI??</span>
                              <input type="submit" style="position: absolute; left: -9999px"/>
                              <br>
                              <br>
                            <q-btn label="Kembali" size="sm" color="grey-7"  v-close-popup/>
                            &nbsp;
                            <q-btn type="submit" label="Hapus" size="sm" color="deep-orange-7" v-close-popup/>

                          </form>
                      </q-card-section>
                    </q-card>
                  </q-dialog>

            <!-- ================================================ MODAL HAPUS ================================================ -->

            <!-- ================================================= MODAL TAMBAH ================================================ -->
              <q-dialog v-model="mdl2" persistent>
                <q-card class="mdl-md">
                  <q-card-section class="bg-light-blue-7">
                    <div class="text-h6 h_modalhead">Delegasikan Laporan</div>
                  </q-card-section>

                  <q-card-section class="q-pt-none">
                        <br>

                        <span class="h_lable ">Kecamatan</span>
                        <q-select outlined v-model="form.kecamatan_id" :options="list_kecamatan" option-label="nama_kecamatan" class="margin_input" square :dense="true" />

                        <span class="h_lable ">Satgas PPPA</span>
                        <q-select outlined v-model="form.satgasId" :options="list_satgas" option-label="nama" class="margin_input" square :dense="true" />

                        <span class="h_lable ">Kategori Laporan</span>
                          <q-select outlined v-model="form.jenis_id" :options="list_jenis" option-label="uraian" class="margin_input" square :dense="true" />

                        <span class="h_lable ">Keterangan</span>
                        <q-input v-model="form.keterangan" outlined square :dense="true" class="bg-white margin_input" type="textarea"/> 

                  </q-card-section>

                  <q-card-actions class="bg-grey-2 mdl-footer" align="right">
                    
                      <q-btn :loading="btn_add" color="light-blue-7" @click="terima_data()" label="Delegasi"  />
                      <q-btn label="Batal" color="grey-7" v-close-popup />
             
                  </q-card-actions>
                </q-card>
              </q-dialog>
            <!-- ================================================= MODAL TAMBAH ================================================ -->

            <!-- ================================================= MODAL KEMBALIKAN ================================================ -->
              <q-dialog v-model="mdl3" persistent>
                <q-card class="mdl-md">
                  <q-card-section class="bg-deep-orange-7">
                    <div class="text-h6 h_modalhead">Kembalikan Data</div>
                  </q-card-section>

                  <q-card-section class="q-pt-none">
                        <br>

                        <span class="h_lable ">Keterangan</span>
                        <q-input v-model="form.keterangan" outlined square :dense="true" class="bg-white margin_input" type="textarea"/> 

                  </q-card-section>

                  <q-card-actions class="bg-grey-2 mdl-footer" align="right">
                    
                      <q-btn :loading="btn_add" color="deep-orange-7" @click="tolak_data()" label="Kembalikan"  />
                      <q-btn label="Batal" color="grey-7" v-close-popup />
             
                  </q-card-actions>
                </q-card>
              </q-dialog>
            <!-- ================================================= MODAL KEMBALIKAN ================================================ -->

            <!-- ================================================= MODAL GAMBAR ================================================ -->
               <q-dialog v-model="mdl_open" persistent>
                <q-card class="mdl-md">
                  <q-card-section class="bg-light-blue-7">
                    <div class="text-h6 h_modalhead">Lihat Image</div>
                  </q-card-section>

                  <q-card-section class="q-pt-none">
                    <br>
                    <div class="modal-body">
                      <center><img class="img-fluid" :src="file_path+form.file_old" width="650px" alt=""></center>
                    </div>
                  </q-card-section>

                  <q-card-actions class="bg-grey-2 mdl-footer" align="right">
                      <q-btn label="Kembali" color="grey-7" v-close-popup />
             
                  </q-card-actions>
                </q-card>
              </q-dialog>
            <!-- ================================================= MODAL GAMBAR ================================================ -->

            <!-- ================================================= MODAL LOKASI ================================================ -->
               <q-dialog v-model="mdl_lokasi" persistent>
                <q-card class="mdl-md">
                  <q-card-section class="bg-cyan-7">
                    <div class="text-h6 h_modalhead">Lokasi</div>
                  </q-card-section>

                    <q-card-section class="q-pt-none">
                      <br>
                      <iframe :src="src_loc+form.lokasi+embed_loc" width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                    </q-card-section>

                  <q-card-actions class="bg-grey-2 mdl-footer" align="right">
                      <q-btn label="Kembali" color="grey-7" v-close-popup />
             
                  </q-card-actions>
                </q-card>
              </q-dialog>
            <!-- ================================================= MODAL LOKASI ================================================ -->

          <!-- =================================================== MODAL =========================================================== -->

  </div>
</template>

<style>
</style>

<script>
export default {
  name: 'UmumPage',
  data() {
    return {
      form : {
        id : '',
        nama : '',
        file : null,
        status : '',
        keterangan : '',
        lokasi : '',
        jenis_id : '',
        userId : '',
        satgasId : '',
        kecamatan_id : '',
        createAt : '',
        editedAt : '',
        file_old : null
      },
      src_loc : "https://maps.google.com/maps?q=",
      embed_loc : "&z=15&output=embed",

      list_data : [],
      list_jenis : [],
      list_kecamatan : [],
      list_satgas : [],
      file_path: this.$store.state.url.URL_APP + "uploads/",

      page_first: 1,
      page_last: 0,
      cari_value: "",

      mdl2: false,
      mdl3: false,
      mdl_lokasi: false,
      mdl_open: false,
    }
  },
  methods: {

    getView : function(){
      this.$store.commit('showLoading');
      fetch(this.$store.state.url.URL_LAPORAN  + "view", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              data_ke: this.page_first,
              cari_value: this.cari_value
          })
      })
          .then(res => res.json())
          .then(res_data => {
              this.list_data = res_data.data;
              this.page_last = res_data.jml_data;
              this.$store.commit("hideLoading");
              console.log(res_data);
      });
    },

    removeData : function(a, b){
      fetch(this.$store.state.url.URL_LAPORAN + "removeData", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({id : a, file : b})
      }).then(res_data => {
          this.Notify('Sukses Menghapus Data', 'deep-orange-7', 'check_circle_outline');
          this.getView();
      });

    },

    getKecamatan : function (){
      fetch(this.$store.state.url.URL_PENGGUNA + "kecamatan", {
          method: "GET",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          // body: JSON.stringify({
          //   data: data,
          // })
        })
          .then(res => res.json())
          .then(res_data => {
            this.list_kecamatan = res_data;
            console.log(this.list_kecamatan);

      });
    },

    getJenis: function() {
        fetch(this.$store.state.url.URL_JENIS, {
            method: "GET",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            }
        })
        .then(res => res.json())
        .then(res_data => {
            // console.log('telasooooo')
        this.list_jenis = res_data;
        console.log(res_data)
        });
    },

    getSatgas: function() {
        fetch(this.$store.state.url.URL_LAPORAN + "satgas", {
            method: "GET",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            }
        })
        .then(res => res.json())
        .then(res_data => {
            // console.log('telasooooo')
        this.list_satgas = res_data;
        console.log(res_data)
        });
    },

    selectData: function(data) {
      this.form.id = data.id
      this.form.file = this.form.file
      this.form.status = data.status
      this.form.keterangan = data.keterangan
      this.form.lokasi = data.lokasi
      this.form.kecamatan_id = data.kecamatan_id
      this.form.jenis_id = data.jenis_id
      this.form.createAt = data.createAt
      this.form.file_old =  data.file
    },

    // ====================================== PAGINATE ====================================
    Notify : function(message, color, icon){
          this.$q.notify({
            message: message,
            color: color,
            icon: icon,
            position : 'center',
            timeout: 500,
          })
        },

        btn_prev : function(){
            this.cek_load_data = true;
            if(this.page_first>1){
                this.page_first--
            }else{
                this.page_first = 1;
            }
            this.getView();
        },

        btn_next : function(){
            if(this.page_first >= this.page_last){
                this.page_first == this.page_last
            }else{
                this.page_first++;
            }
            this.getView();
        },

        cari_data : function(){
            this.page_first = 1;
            this.getView();
        },

    // ====================================== PAGINATE ====================================

  },
  mounted() {
    this.getView();
    this.getKecamatan();
    this.getJenis();
    this.getSatgas();
    this.getKecamatan();
  }
}
</script>
